<template>
 <div class="candidatesAnnouncement">
   <div class="basic">
     <div class="title van-multi-ellipsis--l2">{{ companyData.projectName }}</div>
     <div>
       <span class="icon_time"></span>
       <span class="text">{{ companyData.publicityTime }}</span>
     </div>
   </div>
   <div class="basic">
     <div class="textTitle">排位一</div>
     <div class="text">{{ companyData.companies[0].name }}</div>
     <div class="textTitle">排位二</div>
     <div class="text">{{ companyData.companies[1].name }}</div>
     <div class="textTitle">排位三</div>
     <div class="text">{{ companyData.companies[2].name }}</div>
   </div>
   <div class="basic">
     <div class="textTitle">项目名称</div>
     <div class="text van-multi-ellipsis--l2">{{ companyData.projectName }}</div>
     <div class="textTitle">项目介绍</div>
     <div class="text">{{ companyData.intro }}</div>
   </div>
 </div>
</template>

<script>
  import { getPublicityInfo } from '@api/information'
export default {
  name: 'candidatesAnnouncement',
  data () {
    return {
      companyData: {}
    }
  },
  created () {
    this.getPublicityInfo()
  },
  methods: {
    // 根据项目id获取你还候选人公告信息
    getPublicityInfo () {
      getPublicityInfo({
        projectId: 52
      }).then(res => {
        if (res.data.code === 200) {
          this.companyData = res.data.data
        } else {
            this.$toastMsg(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/mixin";
.candidatesAnnouncement{
  padding: 15px;
  .title{
    @include add_size($font_size_17);
    color: #333;
  }
  .text{
    @include add_size($font_size_15);
    color: #999;
    margin-left: 5px;
  }
}
</style>
